import { useOpportunityChangedSubscription } from "@qw/graphql";
import { useInboxInsured } from "@/providers/use-inbox-insured";
import { Section, SectionHeader } from "../components/section";
import { ActiveOpportunity } from "./active-opportunity";

export const ActiveOpportunities = ({
  liveUpdates = true,
  showSubmissions = true,
}: {
  liveUpdates?: boolean;
  showSubmissions?: boolean;
}) => {
  const { insuredId, activeOpportunities, refetchOpportunities } = useInboxInsured();

  useOpportunityChangedSubscription({
    onData: () => refetchOpportunities(),
    skip: !liveUpdates || !insuredId,
    variables: { insuredId: insuredId || "" },
  });

  return (
    <Section>
      <SectionHeader count={activeOpportunities.length}>Active Marketing Plans</SectionHeader>
      {activeOpportunities.map((opportunity) => (
        <ActiveOpportunity
          key={opportunity.id}
          liveUpdates={liveUpdates}
          opportunity={opportunity}
          refetch={refetchOpportunities}
          showSubmissions={showSubmissions}
        />
      ))}
    </Section>
  );
};
